module.exports = __webpack_public_path__ + "static/media/proj2.3515d6be.jpg";